import type { FaireProductEntity } from "../../entity_types/product";

export const p_f8su5b9tkv: FaireProductEntity = {
  token: "p_f8su5b9tkv",
  type: "product",
  name: "Milky Santal– HI-FI Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/fb397180955ad57cbba3f952a417a8fd660ae0200877f7fa785212daad4d2b19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/02b4ea477f6f74c1bf26ed524e3a15cc7f0bb24c0d4ccf526bcf9549fb215776.jpeg",
    "https://cdn.faire.com/fastly/034231084aad5049c09bd3cb86bebbbd1c79660176f68846bdf863a8443ca46d.jpeg",
    "https://cdn.faire.com/fastly/1bf2d3826b3d2c1352108216fa7b9940ae25b652cf4145e1b78ce76724d60c33.jpeg",
    "https://cdn.faire.com/fastly/1efbdbab20d56c469535ae300b7de2a9a090507e89c8967eb1bc4707d5a8be5e.jpeg",
  ],
  priceDollars: 21.5,
  description:
    "A creamy, grounding gourmand. Rice milk vapor, warm plush robes, grounding sandalwood.\n\nMilky Santal is an elevated, lactonic take on a gourmand. Comforting, soft, and quietly luxurious, like a warmed plush robe and rice milk-infused baths. Skin-like musks and nuanced woods bring a velvet complexity, instantly upping the coziness. \n\nTop notes of rice milk vapor, oats, and patchouli leaf are blended with santal, warm cashmere, and white jasmine, then slightly sweetened by creamy tonka bean, musk, ambrette seed, and woody amyris, creating a nuanced gourmand.\n\nPRODUCT INFORMATION: \n\nOur 13 oz Double Wick Hi-Fi Candles are hand-poured into premium cocoa brown vessels with a vermilion debossed label, and packaged in a premium paper gift box.\n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for up to 60 hours.",
  tags: [],
  msrpDollars: 43.98,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:04:00.180Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
